<template>
  <div class="tw-relative tw-w-full">
    <router-view />
    <vue3-progress-bar />
    <t-toasts />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

import TToasts from "@/components/TToasts";
import { useTheme } from "@/composables";
import { setupDayjsLocale } from "@/plugins/i18n-dayjs";

type AuthUser = {
  accountname: string;
  email: string;
  id: string;
  twoFactorAuthEnabled?: boolean;
};

const store = useStore();
const router = useRouter();
const i18n = useI18n();

useTheme();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
setupDayjsLocale(i18n as any);

const authUser = computed<AuthUser | null>(
  () => store.getters["authentication/authUser"],
);

onMounted(async () => {
  await router.isReady();

  const route = router.currentRoute.value;
  const path = route?.path || "/";

  if (
    !authUser.value &&
    !path.includes("/sso/callback") &&
    !path.includes("/azure/callback") &&
    !path.includes("auth/password/set") &&
    !path.includes("/auth/sign-in")
  ) {
    localStorage.clear();

    const queryParams: Record<string, string> = {};
    const currentFullPathForRedirect = route?.fullPath || path;
    if (
      currentFullPathForRedirect &&
      currentFullPathForRedirect !== "/" &&
      currentFullPathForRedirect.trim() !== ""
    ) {
      queryParams.redirect = currentFullPathForRedirect;
    }

    router.push({
      name: "auth-sign-in",
      query: queryParams,
    });
  }
});
</script>
